module.exports = __webpack_public_path__ + "img/FATHERS DAY.f5511eb.svg";